(function () {
  var locale = String((window.SAMATRIP && SAMATRIP.locale) || document.documentElement.lang || 'fr')
    .toLowerCase()
    .split('-')[0];
  if (!locale || locale === 'fr') return;

  var ARABIC = /[\u0600-\u06FF]/;
  var catalog = {};
  var catalogUrl = (window.SAMATRIP && SAMATRIP.catalogI18n) || '';

  var INCLUSIONS_AR = {
    'Vol inclus': 'رحلة طيران مشمولة',
    'Hôtel 4★': 'فندق 4★',
    'Hôtel 5★': 'فندق 5★',
    'Hôtel 3★': 'فندق 3★',
    'Hôtel 3★/4★': 'فندق 3★/4★',
    'Petit-déjeuner': 'إفطار',
    'Demi-pension': 'نصف إقامة',
    'All inclusive': 'شامل كلياً',
  };

  function translateDuration(text) {
    if (locale !== 'ar') return text;
    return String(text)
      .replace(/Jours/gi, 'أيام')
      .replace(/Jour/gi, 'يوم')
      .replace(/Nuits/gi, 'ليال')
      .replace(/Nuit/gi, 'ليلة');
  }

  function applyCatalog() {
    if (!catalog[locale]) return;
    document.querySelectorAll('[data-i18n-handle]').forEach(function (card) {
      var handle = card.getAttribute('data-i18n-handle');
      var title = catalog[locale][handle];
      if (title) {
        card.querySelectorAll('[data-i18n-field="title"]').forEach(function (el) {
          el.textContent = title;
        });
      }
      card.querySelectorAll('[data-i18n-field="duration"]').forEach(function (el) {
        el.textContent = translateDuration(el.textContent);
      });
      card.querySelectorAll('[data-i18n-field="inclusion"]').forEach(function (el) {
        var src = el.textContent.trim();
        if (locale === 'ar' && INCLUSIONS_AR[src]) el.textContent = INCLUSIONS_AR[src];
      });
    });
    var path = (location.pathname || '').replace(/\/+$/, '').split('/');
    var handle = path[path.length - 1];
    if (catalog[locale][handle]) {
      document.querySelectorAll('h1.product__title, .product-title, [data-product-title]').forEach(function (el) {
        el.textContent = catalog[locale][handle];
      });
    }
  }

  function loadCatalog() {
    if (!catalogUrl) {
      applyCatalog();
      return Promise.resolve();
    }
    return fetch(catalogUrl)
      .then(function (res) {
        return res.ok ? res.json() : {};
      })
      .then(function (data) {
        catalog = data || {};
        applyCatalog();
      })
      .catch(function () {
        applyCatalog();
      });
  }

  function looksFrench(text) {
    var t = String(text || '').replace(/\s+/g, ' ').trim();
    if (t.length < 3) return false;
    if (ARABIC.test(t)) return false;
    if (/^[\d€$£¥.,\s/%:+\-–—°★*#()]+$/.test(t)) return false;
    return (
      /[àâäéèêëïîôùûüçœæ]/i.test(t) ||
      /\b(le|la|les|des|une|est|pour|avec|dans|votre|nous|circuit|séjour|jours|nuits|inclus|hôtel|vol|package|dossier|agence|voyage|voir|tous|paiement|sécurisé|recherche|départ|arrivée|voyageur)\b/i.test(t)
    );
  }

  function translateGoogle(text) {
    var url =
      'https://translate.googleapis.com/translate_a/single?client=gtx&sl=fr&tl=' +
      encodeURIComponent(locale) +
      '&dt=t&q=' +
      encodeURIComponent(text);
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('http');
        return res.json();
      })
      .then(function (data) {
        return ((data && data[0]) || [])
          .map(function (row) {
            return row[0];
          })
          .join('')
          .trim();
      });
  }

  function leftoverFrench() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) {
      var node = walker.currentNode;
      var parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|OPTION)$/.test(parent.tagName)) continue;
      if (parent.closest('[data-no-translate], [translate="no"], .lang-flags, .money')) continue;
      if (looksFrench(node.nodeValue)) nodes.push(node);
    }
    var chain = Promise.resolve();
    nodes.forEach(function (node) {
      var src = node.nodeValue.replace(/\s+/g, ' ').trim();
      chain = chain.then(function () {
        return translateGoogle(src).then(function (out) {
          if (out && out !== src) node.nodeValue = node.nodeValue.replace(src, out);
        }).catch(function () {});
      });
    });
    return chain;
  }

  loadCatalog().then(function () {
    if (locale === 'ar') leftoverFrench();
  });
})();
